import {
  getFoodProductList,
  setFoodProductList,
  addFoodProductToList,
  addFoodProductToListSuccess,
  addFoodProductToListFailure,
  deleteFoodProduct,
  deleteFoodProductSuccess,
  deleteFoodProductFailure,
  editFoodProduct,
  editFoodProductSuccess,
  editFoodProductFailure
} from "../actions/foodProductListAction";
import { handleActions } from "redux-actions";

const initState = {
  foodProducts: {
    data: []
  },
  tableLoading: false,
  buttonLoading: false,
  errorMessage: null,
  updated: false
};

const foodProductListReducer = handleActions(
  {
    [getFoodProductList]: state => {
      return { ...state, tableLoading: true };
    },
    [setFoodProductList]: (state, { payload: { foodProducts } }) => {
      return { ...state, foodProducts: foodProducts, tableLoading: false, updated: false };
    },
    [addFoodProductToList]: (state, action) => {
      return { ...state, buttonLoading: true };
    },
    [addFoodProductToListSuccess]: (state, action) => {
      return {
        ...state,
        buttonLoading: false
      };
    },
    [addFoodProductToListFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, buttonLoading: false };
    },
    [deleteFoodProduct]: state => {
      return { ...state, tableLoading: true };
    },
    [deleteFoodProductSuccess]: state => {
      return { ...state, tableLoading: false };
    },
    [deleteFoodProductFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    },
    [editFoodProduct]: state => {
      return { ...state, tableLoading: true };
    },
    [editFoodProductSuccess]: state => {
      return { ...state, tableLoading: false, updated: true};
    },
    [editFoodProductFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    }
  },
  initState
);

export default foodProductListReducer;
